import { render } from "./lxcgVersionMa.vue?vue&type=template&id=83b3f466&scoped=true"
import script from "./lxcgVersionMa.vue?vue&type=script&lang=js"
export * from "./lxcgVersionMa.vue?vue&type=script&lang=js"

import "./lxcgVersionMa.vue?vue&type=style&index=0&id=83b3f466&lang=scss&scoped=true"

import exportComponent from "/data/jenkins-workspace/workspace/Publicar_automáticamente_por_Lianxin/联心运营后台前端【生产】/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b3f466"]])

export default __exports__